import { icons } from "constants/icons";
import {
  RefObject,
  useEffect,
  useRef,
} from "react";
import DefaultDatePicker, { ReactDatePickerProps } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

type Props = {
  hint? : string;
  minDate? : Date;
  date: Date | null;
  onChange?: any;
  disabled?: boolean
};

export const DatePicker = ({
  hint,
  minDate,
  date,
  onChange,
  disabled
}: ReactDatePickerProps & Props) => {
  const datePickerRef: RefObject<any> = useRef();

  useEffect(() => {
    datePickerRef?.current.setOpen(false);
  }, [date]);
  
  return (
    <div
      aria-hidden="true"
      className="flex items-center bg-border p-3 rounded-[10px] text-grayDark text-sm outline-none"
      onClick={() => datePickerRef?.current.setFocus()}
    >
      <DefaultDatePicker
        ref={datePickerRef}
        selected={date}
        placeholderText={hint ?? "Select Date"}
        minDate={minDate ? minDate :new Date(2020, 10, 10)}
        onChange={onChange}
        disabled={disabled}
        dateFormat="MM/dd/yyyy"
        className="bg-border  rounded-[10px] text-grayDark text-sm w-[94px] outline-none"
      />

      <img src={icons.calendar} alt="calendar" />
    </div>
  );
};
